// import $ from 'jquery' // jQuery
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉
import 'intersection-observer' // intersection-observerをimportし対応。
import scrollLock from './functions/_scrollLock.js' // スクロールロック

/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
// import './_success.js'
// import './_impressed.js'
// import './_talk.js'
import './_form.js'
import './_under.js'

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.animatedを付加
// Intersection Observer
window.intObs = function (rootMargin) {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  console.log('added')
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

if (!document.getElementById('page-top')) {
  window.intObs('-10% 0px')
}

//  #####     ###    #####      ###              ######   #####    #####   ###    ###
//  ##  ##   ## ##   ##  ##    ## ##                ##   ##   ##  ##   ##  ## #  # ##
//  #####   ##   ##  #####    ##   ##  ########    ##    ##   ##  ##   ##  ##  ##  ##
//  ##      #######  ##  ##   #######             ##     ##   ##  ##   ##  ##      ##
//  ##      ##   ##  ##   ##  ##   ##            ######   #####    #####   ##      ##
/*

      <div id="mvBox" class="js-scrollZoom mvBox anime chain fade-in wave4">
          <div class="mvBox__item">
              <div id="topMv" class="swiper-container">

              </div>
          </div>
      </div>

*/

//  ##  ##     ##  ######             ####  ##   ##  ##  #####  ######
//  ##  ####   ##    ##              ##     ##   ##  ##  ##       ##
//  ##  ##  ## ##    ##    ########   ###   #######  ##  #####    ##
//  ##  ##    ###    ##                 ##  ##   ##  ##  ##       ##
//  ##  ##     ##    ##              ####   ##   ##  ##  ##       ##
// 背景の色をシフトさせる
/*
<section class="topFront shiftRed js-shiftArea">
</section>
*/

// 画面に入った監視対象に.shiftを付加
// Intersection Observer
window.shiftArea = function () {
  if (!document.getElementsByClassName('js-shiftArea')[0]) {
    return
  }

  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-60% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-shiftArea')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      const entryItem = entry.target
      if (entry.isIntersecting) {
        entryItem.classList.add('shift')
      } else {
        entryItem.classList.remove('shift')
      }
    }
  }
}
window.shiftArea()

//   #####   ##   ##  #####  #####    ##        ###    #####
//  ##   ##  ##   ##  ##     ##  ##   ##       ## ##   ##  ##
//  ##   ##  ##   ##  #####  #####    ##      ##   ##  #####
//  ##   ##   ## ##   ##     ##  ##   ##      #######  ##
//   #####     ###    #####  ##   ##  ######  ##   ##  ##

/**
 * @function scrollOverlap
 * @description スクロール後、指定の要素同士が接触しているかを判定する
 * @param {String} baseSelector 監視対象とする一意なセレクタ
 * @param {String} targetSelector 接触対象とするセレクタ　複数
 * @param {String} className 着脱するクラス名
 * @return {Void}
scrollOverlap('#hogeID', '.js-hoge', 'active')
 */
scrollOverlap('#fixNav', '.js-shiftArea', 'shift')
function scrollOverlap(baseSelector, targetSelector, className = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  const baseItem = document.querySelector(baseSelector) // 監視要素
  const targetList = document.querySelectorAll(targetSelector) // 接触対象
  let isHit = false // ヒット判定フラグ
  let isLastHit = false // 直近のヒット判定フラグ

  document.addEventListener('scroll', function (ev) {
    scrollOverlapApply()
  })
  scrollOverlapApply() // 初回起動
  function scrollOverlapApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true

    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      for (const target of targetList) {
        if (checkOverlap(baseItem, target)) {
          isHit = true
          break
        }
      }
      // ヒット状態が変わった場合の追加処理
      if (isHit !== isLastHit) {
        if (isHit) {
          baseItem.classList.add(className)
        } else {
          baseItem.classList.remove(className)
        }
        isLastHit = isHit
      }
      isHit = false

      isExecute = false
    })
  }
  /**
   * @function checkOverlap
   * @description 2つの要素同士が重なっているかを判定する
   * @param {element} item1
   * @param {element} item2
   * @returns {boolean}
   */
  function checkOverlap(item1, item2) {
    const d1 = item1.getBoundingClientRect()
    const d2 = item2.getBoundingClientRect()
    return !(d1.top > d2.bottom || d1.right < d2.left || d1.bottom < d2.top || d1.left > d2.right)
  }
}

//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######

/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
scrollValToggle('#hogeID', 500, false,'active')
*/
scrollValToggle('#topNews', 50, false, 'hide')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  if (document.body.classList.contains('js-scrollLock--active')) {
    return
  }

  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

/*
 ######   ######          ##    ##    ###    ##     ##
##       ##               ####  ##  ##   ##  ##     ##
 ######  ##       ####### ## ## ## ##     ## ##     ##
      ## ##               ##  #### #########  ##   ##
 ######   ######          ##    ## ##     ##    ###

ターゲットが走査線に入ったら連動する要素にクラスを当てる
Intersection Observer APIを使用

<a href="#hoge" class="js-scrollNav js-scrollNav--hoge"></a>
<section id="hoge" class="js-scrollNav-trigger" data-nav-target="hoge">
  section#hogeが画面に入ったらjs-scrollNav--hogeにクラスを当てる
</section>
*/

if (document.getElementsByClassName('js-scrollNav')[0]) {
  scrollNav()
}
function scrollNav() {
  const navItems = document.getElementsByClassName('js-scrollNav')
  const intObsOption = {
    rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(scrollNavCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-scrollNav-trigger')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function scrollNavCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      // 接触アイテムを発見
      if (entry.isIntersecting) {
        // 全ての.activeを外す
        for (let index = 0; index < navItems.length; index++) {
          navItems[index].classList.remove('current')
        }
        const entryItem = entry.target
        const target = entryItem.dataset.navTarget // 制御対象名を取得

        // 対象アイテムをアクティブにする
        const targetItems = document.getElementsByClassName('js-scrollNav--' + target)
        for (let index = 0; index < targetItems.length; index++) {
          const targetItem = targetItems[index]
          targetItem.classList.add('current')
        }
        break // 以降の判定は飛ばす
      }
    }
  }
}

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######

const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
const modalYoutube = document.getElementsByClassName('js-modal-youtube') // モーダル内YouTube
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    modalOverlay.classList.add('active')
    scrollLock('body', '#modalOverlay')

    // YouTubeのsrcを読み込む
    const youtube = document.querySelector('.js-modal--' + target + ' .js-modal-youtube')
    if (youtube) {
      youtube.setAttribute('src', youtube.dataset.src)
    }
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    modalOverlay.classList.remove('active')
    scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
  // YouTubeのsrcを消して動画を止める
  for (let index = 0; index < modalYoutube.length; index++) {
    modalYoutube[index].setAttribute('src', '')
  }
}
